// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["collapsed", "expanded", "label", "preferences", "instrument", "level"];

  #open = false;
  #originalLabel = "";
  #label = "";
  #url = false;
  #placeable = false;
  #level = undefined;
  #instrument = undefined;
  #wizardButtons;

  connect() {
    this.#wizardButtons = document.querySelectorAll("#wizardSteps");
    this.#url = this.element.getAttribute("data-class-options-url");
    this.#originalLabel = this.labelTarget.innerText.replace(/[\n\r]+|[\s]{2,}/g, " ").trim();
    this.expandedTarget.addEventListener("submitted", () => this.onSubmit());
    this.instrumentTarget.addEventListener("change", (e) => this.onInstrumentUpdate(e));
    this.levelTarget.addEventListener("change", (e) => this.onLevelUpdate(e));
    this.#level = this.levelTarget.value;
    this.#instrument = this.instrumentTarget.value;

    this.makePlaceable();
  }

  toggle() {
    this.#open = !this.#open;
    this.collapsedTarget.hidden = this.#open;
    this.expandedTarget.hidden = !this.#open;

    if (!this.#open) {
      this.fireCloseNewFormEvent();
    }
  }

  fireCloseNewFormEvent() {
    const event = new CustomEvent("close-new-form", { bubbles: true });
    this.element.dispatchEvent(event);
  }

  async onInstrumentUpdate(e) {
    if (e.target.value !== this.#instrument) {
      this.#instrument = e.target.value;
      await this.requestPreferredClasses();
    }
  }

  async onLevelUpdate(e) {
    if (e.target.value !== this.#level) {
      this.#level = e.target.value;
      await this.requestPreferredClasses();
    }
  }

  async requestPreferredClasses() {
    if (this.#level !== undefined && this.#instrument !== undefined) {

      if (this.#placeable) {
        this.#placeable = false;
        const content = await (await fetch(this.#url + `?level=${this.#level}&instrument_type=${this.#instrument}`)).text();
        this.preferencesTarget.innerHTML = content;
        this.makePlaceable();
      }
    }
  }

  makePlaceable() {
    setTimeout(() => {
      this.#placeable = true;
    }, 2000);
  }
}
